import { translateString } from "@/functions/functions.js";
export const stepsPneus = [
  {
    stepId: 1,
    name: "selectQuantity",
    title: translateString("tireReplacement"),
    description: translateString("chooseTireService"),
  },
  {
    stepId: 2,
    name: "medidas",
    title: translateString("tireReplacement"),
    description: translateString("selectTireSize"),
  },
  {
    stepId: 3,
    title: translateString("tireReplacement"),
    name: "selectPhneus",
    description: translateString("selectFrontTires"),
  },
  {
    stepId: 4,
    title: translateString("tireReplacement"),
    name: "selectPhneus",
    description: translateString("selectRearTires"),
  },
];